var __jsx = React.createElement;
import React from "react";
import { useIsMobile } from "@/common/Contexts/IsMobileContext";
import { twMerge } from "tailwind-merge";
import { useCMS } from "@hooks/useCMS";
var IndicatorsCards = function IndicatorsCards(_ref) {
  var data = _ref.data;
  var isMobile = useIsMobile();
  var _useCMS = useCMS(),
    imageUrl = _useCMS.imageUrl;
  var stats = data.payloads.map(function (item) {
    return {
      icon: item.icon,
      value: item.title,
      label: item.subtitle
    };
  });
  return /*#__PURE__*/React.createElement("div", {
    id: "indicators-section",
    className: "py-4 md:py-16 px-4 bg-white",
    dir: "rtl"
  }, /*#__PURE__*/React.createElement("div", {
    id: "indicators-container",
    className: "max-w-[1200px] mx-auto"
  }, /*#__PURE__*/React.createElement("div", {
    id: "indicators-grid",
    className: "grid grid-cols-2 md:grid-cols-2 gap-4 md:gap-6"
  }, stats.map(function (stat, index) {
    return /*#__PURE__*/React.createElement("div", {
      id: "indicator-card-".concat(index),
      key: index,
      className: twMerge(isMobile ? "bg-[#E7E7F8]" : "bg-[#F3F3FB]", "rounded-2xl px-4 py-6 flex flex-col items-center justify-center text-center")
    }, /*#__PURE__*/React.createElement("div", {
      id: "indicator-icon-container-".concat(index),
      className: twMerge(" rounded-full flex items-center justify-center mb-4 md:mb-8", isMobile ? "w-16 h-16 md:w-20 md:h-20 border-[1px] border-solid border-primary-new bg-white p-4" : "w-28 h-28 bg-[#0D0DB50D]")
    }, /*#__PURE__*/React.createElement("img", {
      id: "indicator-icon-".concat(index),
      loading: "lazy",
      src: imageUrl(stat.icon),
      alt: stat.label,
      className: "w-10 h-10 md:w-16 md:h-16 object-contain"
    })), /*#__PURE__*/React.createElement("div", {
      id: "indicator-value-".concat(index),
      className: "text-[36px] md:text-[40px] font-bold text-primary-new mb-2 md:mb-4"
    }, stat.value), /*#__PURE__*/React.createElement("span", {
      id: "indicator-label-".concat(index),
      className: "text-[16px] md:text-xl font-semibold"
    }, stat.label));
  }))));
};
export default IndicatorsCards;